<template>
  <div class="tableMask exam-container">
    <div class="anList">
      <div class="antitle">
        <h3>{{ courseName }}</h3>
        <div class="toolbar"><strong>目录（考试分成以下{{ quesCount }}个部分）：</strong></div>
      </div>
      <div class="anbody">
        <table>
          <tr v-for="(item,idx) in questions"
              :key="idx">
            <td>
              <h4>{{ item.showSerialNum }}、{{ item.viewTypeName }}</h4>
              <p v-if="isShowDetail">{{ item.quesTypeDesc }}</p>
            </td>
            <td width="150"
                align="right">
              <a href="javascript:void(0)"
                 class="startExam"
                 @click="startExam(idx)">点击进入</a>
            </td>
          </tr>
        </table>
      </div>
      <div class="anfooter fff">
        <div v-if="commonInfo.timerMode == 1">
          <div class="tip" v-if="!isChapter">注意：本场考试时间为<span
              style="color:red;">{{ exerciseTime ? exerciseTime : commonInfo.contestTimeLimit }}分钟</span>。
          </div>
          <div class="tip" v-if="isChapter">注意：本场考试时间为<span style="color:red;">{{ Math.floor(commonInfo.lastTime / 60) }}分钟</span>。
          </div>
        </div>
        <div class="button">
          <a v-if="$route.query.flag !== 'ordinary'"
             href="javascript:void(0)"
             class="an toPrev"
             @click="toPrev">返回</a>
          <a href="javascript:void(0)"
             class="an toNext"
             @click="toNext">继续</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {isCompositeCourse} from "@/utils"

export default {
  name: 'ExamStartPage',
  props: {
    isShowDetail: {
      type: Boolean,
      default: true,
    },
    exerciseTime: {
      type: Number,
    },
    courseName: {
      type: String,
      default: '',
    },
    isChapter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['commonInfo', 'questions', 'currentQuestion']),
    quesCount() {
      let list = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      let len = Object.keys(this.questions).length
      return list[len - 1]
    },
  },
  data() {
    return {
      flag: '',
      siteCourseID: '',
      courseID: '',
    }
  },
  mounted() {
    const {flag} = this.$route.params
    this.flag = flag === 'paidExam' ? '' : flag
    const {siteCourseID, courseID} = this.$route.query
    this.siteCourseID = siteCourseID
    this.courseID = courseID
    //处理综合不显示目录信息
    if (isCompositeCourse(siteCourseID, courseID)) {
      this.toNext()
      this.$emit('zhAutoExam', true)
    } else {
      this.$emit('zhAutoExam', false)
    }
    // console.log(this.questions)
  },
  methods: {
    startExam(quesType) {
      // this.$store.dispatch('setCurQuesType', quesType)
      // this.$store.dispatch('setCurQuesIndex', quesIndex)
      // this.$store.dispatch('setCurQues', this.questions[quesType].list[quesIndex])
      let questions = []
      let currentTypeQuestions = this.questions[quesType]
      if (currentTypeQuestions.list.length > 0) {
        currentTypeQuestions.list.forEach((item, i) => {
          Object.assign(item, {index: i})
        })
        questions = [...currentTypeQuestions.list]
      }

      let idx = questions.findIndex((item) => {
        if (item.smallContent) {
          // 大题套小题
          let res = item.smallContent.some((smallQues) => {
            let hasAnswer = false
            if (smallQues.attAnswer) {
              hasAnswer = smallQues.isAnswer === 1
            } else {
              hasAnswer =
                  smallQues.userAnswer && smallQues.userAnswer.length > 0
            }
            return hasAnswer
          })
          return !res
        } else {
          if (item.userAnswer instanceof Array) {
            //  多选题
            return item.userAnswer.length === 0
          } else {
            //  其他简单题型
            let hasAnswer = false
            if (item.attAnswer) {
              hasAnswer = item.tempAnswer === 'true'
            } else {
              hasAnswer = item.userAnswer && item.userAnswer.length > 0
            }
            return !hasAnswer
          }
        }
      })

      // 是否全部已做
      idx = idx === -1 ? questions.length - 1 : idx

      this.$store.dispatch('setCurQuesType', quesType)
      this.$store.dispatch('setCurQuesIndex', questions[idx].index)
      this.$store.dispatch(
          'setCurQues',
          this.questions[quesType].list[questions[idx].index]
      )
      this.$emit('examStart', true)
    },
    toPrev() {
      if (this.$route.query.chapterID || this.$route.query.paperRedo) {
        this.$router.go(-1)
      } else {
        this.$emit('showExamPage', false)
      }
    },
    toNext() {
      // this.$store.dispatch('setCurQuesType', 0)
      // this.$store.dispatch('setCurQuesIndex', 0)
      // this.$store.dispatch('setCurQues', this.questions[0].list[0])
      this.judgeCurrentExercise()
      this.$emit('examStart', true)
    },
    // 判断当前做题情况，若均未做----跳转至第一题，若均做----跳转至最后一题，若部分已做，则跳转到最前面的一道未做题
    judgeCurrentExercise() {
      let allQuestions = []
      Object.keys(this.questions).forEach((type, index) => {
        allQuestions[index] = []
        if (this.questions[type].list.length > 0) {
          this.questions[type].list.forEach((item, i) => {
            Object.assign(item, {quesTypeCopy: Number(type), index: i})
          })
        }

        allQuestions[index] = [...this.questions[type].list]
      })
      allQuestions = Array.prototype.concat([], ...allQuestions)
      // 第一道未做题的index
      let idx = allQuestions.findIndex((item) => {
        if (item.smallContent) {
          // 大题套小题
          let res = item.smallContent.some((smallQues) => {
            let hasAnswer = false
            if (smallQues.attAnswer) {
              hasAnswer = smallQues.isAnswer === 1
            } else {
              hasAnswer =
                  smallQues.userAnswer && smallQues.userAnswer.length > 0
            }
            return hasAnswer
          })
          return !res
        } else {
          if (item.userAnswer instanceof Array) {
            //  多选题
            return item.userAnswer.length === 0
          } else {
            //  其他简单题型
            let hasAnswer = false
            if (item.attAnswer) {
              hasAnswer = item.tempAnswer === 'true'
            } else {
              hasAnswer = item.userAnswer && item.userAnswer.length > 0
            }
            return !hasAnswer
          }
        }
      })
      // 是否全部已做
      idx = idx === -1 ? allQuestions.length - 1 : idx
      this.$store.dispatch('setCurQuesType', allQuestions[idx].quesTypeCopy)
      this.$store.dispatch('setCurQuesIndex', allQuestions[idx].index)
      this.$store.dispatch(
          'setCurQues',
          this.questions[allQuestions[idx].quesTypeCopy].list[
              allQuestions[idx].index
              ]
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.exam-container {
  top: 45px;
  background: #e5e9f5;

  .anList {
    top: 0;
    width: 80%;
    height: 100%;
    padding: 0 16px 30px 16px;
    max-width: none;
    background: transparent;
    overflow-y: auto;

    .antitle {
      margin-bottom: 10px;
      line-height: 34px;
      font-size: 17px;

      > h3 {
        line-height: 50px;
        padding: 10px 0 15px;
        text-align: center;
        margin-bottom: 0;
      }
    }

    .anbody {
      box-shadow: 0 0 10px 10px #dae0f0;
      width: 100%;
      max-height: 500px;
      background: #ffffff;
      overflow-y: auto;
      padding: 10px 30px;

      table {
        width: 100%;
        border-collapse: collapse;
        font-size: 14px;

        tr {
          padding: 10px 0;
          min-height: 100px;
          border-bottom: 2px dotted #ddd;
          position: relative;

          &:last-child {
            border-bottom: 0;
          }
        }

        td {
          line-height: 24px;
          padding: 10px 0;

          > h4 {
            min-height: 24px;
          }
        }

        .startExam {
          height: 30px;
          padding: 5px 20px;
          line-height: 30px;
          font-size: 14px;
          color: #ffffff;
          border-radius: 3px;
          background: #ff925a;
          box-shadow: none !important;
          border: 1px solid #ff925a;
          transition: all 0.3s;
        }
      }
    }

    .anfooter.fff {
      position: relative;
      background: transparent;
      text-align: center;

      .tip {
        text-align: left;
        margin-top: 20px;
        font-size: 17px;
        font-weight: bold;
      }

      .button {
        width: 450px;
        margin: 10px auto;
        text-align: center;

        .an {
          display: inline-block;
        }

        .toPrev {
          background: #818ca2;
          border: 1px solid #818ca2;
          transition: all 0.3s;
          margin-right: 40px;
        }
      }
    }
  }
}
</style>
